<div mat-dialog-title class="title">
    Đổi mật khẩu
</div>
<mat-dialog-content>
    <div class="pt-5">
        <form [formGroup]="form" class="form-control">
            <div class="flex m-2">
                <label for="" class="whitespace-nowrap min-w-[45%]">Mật khẩu</label>
                <mat-form-field class="w-full text-base" appearance="outline">
                    <input matInput [type]="hideOldPassword ? 'password' : 'text'" formControlName="oldPassword">
                    <button mat-icon-button matSuffix (click)="hideOldPassword = !hideOldPassword"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideOldPassword">
                        <mat-icon>{{hideOldPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error class="text-base"
                        *ngIf="form.get('oldPassword').invalid">{{getErrorMessage(form.get('oldPassword'))}}</mat-error>
                </mat-form-field>
            </div>
            <div class="flex m-2">
                <label for="" class="whitespace-nowrap min-w-[45%]">Mật khẩu mới</label>
                <mat-form-field class="w-full text-base" appearance="outline">
                    <input matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="newPassword">
                    <button mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNewPassword">
                        <mat-icon>{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error class="text-base"
                    *ngIf="form.get('newPassword').invalid">{{getErrorMessage(form.get('newPassword'))}}</mat-error>
                </mat-form-field>
            </div>
            <div class="flex m-2">
                <label for="" class="whitespace-nowrap min-w-[45%]">Nhập lại mật khẩu mới</label>
                <mat-form-field class="w-full text-base" appearance="outline">
                    <input matInput [type]="hideConfirmPassword ? 'password' : 'text'"
                        formControlName="confirmPassword">
                    <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword">
                        <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error class="text-base"
                    *ngIf="form.get('confirmPassword').invalid">{{getErrorMessage(form.get('confirmPassword'))}}</mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions w-full">
    <button class="text-base whitespace-nowrap" mat-button cdkFocusInitial (click)="onSubmit()">
        Xác nhận
    </button>
    <button class="text-base whitespace-nowrap" mat-button mat-dialog-close>Đóng</button>
</mat-dialog-actions>